<template>
  <a-modal
    width="1300px"
    :title="$tc('lang.menuGoodsSpace.history_orders')"
    :visible="visible"
    @cancel="$emit('cancel')"
    @ok="handleModalOk"
  >
  <div style="display: flex; margin-bottom: 12px;"><a-input
            v-model="tel"
            style="width: 230px;margin-right: 12px;"
                type="text"
                placeholder="请输入手机号"
              ></a-input><a-input
               style="width: 230px;margin-right: 12px;"
            v-model="factory"
                type="text"
                placeholder="请输入工厂名称"
              ></a-input><a-input
            v-model="person"
             style="width: 230px;margin-right: 12px;"
                type="text"
                placeholder="请输入联系人"
              ></a-input>
                <a-button type="primary" @click="getSearch">
      搜索
    </a-button> </div>
    <a-table
      class="data-table"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      :columns="columns"
      :dataSource="tableData"
      :scroll="{ x: 1200 }"
      size="small"
      @change="handleTableChange"
    >
      <div slot="action" slot-scope="text, record">
        <a @click="continueOrder(record)">
          {{ $tc('lang.menuGoodsSpace.continue_order') }}
        </a>
      </div>
    </a-table>
  </a-modal>
</template>

<script>
import moment from 'moment';

export default {
  name: 'HistoryOrderModal',
  props: {
    visible: Boolean,
    item: Object,
  },
  data() {
    return {
      tableData: [],
      factoryInfo: {},
      loading: false,
      tel: '',
      factory:  '',
      person:  '',
      columns: [
        {
          title: this.$tc('lang.menuGoodsSpace.Vendor_Name'),
          dataIndex: 'orderFactoryname',
          key: 'orderFactoryname',
          width: 100,
        },
        {
          title: this.$tc('lang.menuGoodsSpace.Region'),
          dataIndex: 'orderFactoryarea',
          width: 120,
          key: 'orderFactoryarea',
        },
        {
          title: this.$tc('lang.menuGoodsSpace.Vendor_Address'),
          dataIndex: 'orderFactoryaddress',
          key: 'orderFactoryaddress',
          width: 120,
        },
        {
          title: this.$tc('lang.orderAll.Service_Date'),
          dataIndex: 'orderServicedate',
          key: 'orderServicedate',
          width: 120,
        },

        {
          title: this.$tc('lang.menuGoodsSpace.Contact_Name'),
          dataIndex: 'orderFactoryperson',
          key: 'orderFactoryperson',
          width: 80,
          align: 'center',
        },
        {
          title: this.$tc('lang.menuGoodsSpace.Telephone'),
          dataIndex: 'orderFactoryfixedtel',
          key: 'orderFactoryfixedtel',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.menuGoodsSpace.Mobile'),
          dataIndex: 'orderFactorytel',
          key: 'orderFactorytel',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.menuGoodsSpace.E_mail'),
          dataIndex: 'orderFactoryemail',
          key: 'orderFactoryemail',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.UserCenter.Operate'),
          key: '20',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pagination: {
        pageSize: 50, // 默认每页显示数量
        total: 0,
        size: 'default',
        // hideOnSinglePage: true,
        showSizeChanger: true, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOption: ['10', '20', '50', '100'],
        showSizeChange: (current, pageSize) => (this.pageSize = pageSize),
        showTotal: (total) => `总计${total}条`,
      },
    };
  },
  created() {
    this.form = this.$form.createForm(this);
  },
  watch: {
    item(item) {
      console.log('item', item);
      this.getData({ ...item, page: 1, size: 50 });
    },
  },
  methods: {
    getSearch() {
      // this.loading = true;
      // this.tableData=[]
      // this.$http
      //   .post('/hzwmj/workorder/selHistoryOrder', {
      //     page: 1, size: 50 ,
      //     factory: this.factory,
      //     person: this.person,
      //     tel: this.tel,
      //   })
      //   .then((result) => {
      //     this.loading = false;
      //     if (result.code == 200) {
      //       this.tableData = result.data.records;
      //       this.tableData.forEach(item => {
      //     // 直接覆盖原字段
      //         item.orderServicedate = item.orderServicedate != null
      //                               ? moment(item.orderServicedate)
      //                               : null;
      //        });
      //       const pagination = { ...this.pagination };
      //       pagination.total = result.data.total;
      //       this.pagination = pagination;
      //     }
      //   })
      //   .catch((e) => {
      //     console.log('Error', e);
      //     this.loading = false;
      //   });
      this.getData({ ...this.item, page: 1, size: 50 });
    },
    getData(item) {
      this.loading = true;
      this.$http
        .post('/hzwmj/workorder/selHistoryOrder', {
          ...item,
          factory: this.factory,
          person: this.person,
          tel: this.tel,
        })
        .then((result) => {
          this.loading = false;
          if (result.code == 200) {
            this.tableData = result.data.records;
                   this.tableData.forEach(item => {
          // 直接覆盖原字段
              item.orderServicedate = item.orderServicedate != null
                                    ? moment(item.orderServicedate)
                                    : null;
             });
            const pagination = { ...this.pagination };
            pagination.total = result.data.total;
            this.pagination = pagination;
          }
        })
        .catch((e) => {
          console.log('Error', e);
          this.loading = false;
        });
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.pagination = pager;
      this.getData({
        page: pager.current,
        size: pager.pageSize,
        ...this.item,
      });
    },
    /**
     * 选择历史订单信息继续下单
     */
    continueOrder(record) {
      console.log(record,'历史订单');
      this.factoryInfo = record;
      this.handleModalOk();
    },
    /*
     * 保存数据
     */
    handleModalOk() {
      this.$emit('ok', this.factoryInfo);
    },
  },
};
</script>
